import React from 'react';
import { checkFreePackage } from '@src/services/package';
import CheckOrCross from '../Shared/CheckOrCross';

const noWatermarkFeatures = ({ packages }) =>
  packages.map((pkg) => (
    <CheckOrCross key={pkg.code} isCheck={!checkFreePackage(pkg?.code)} />
  ));
export default noWatermarkFeatures;
